export default {
	title: "Orixás",
	name: "Nome",
	color: "Cor",
	create: "Novo Orixá",
	edit: "Editar Orixá",
	confirmDeleteMessage: "Deseja realmente excluir o orixá {name}? Pessoas vinculadas terão o campo limpo.",
	searchPlaceholder: "Buscar orixá...",
	noData: "Nenhum orixá cadastrado",
	stats: {
		total: "Total",
	},
	messages: {
		createSuccess: "Orixá criado com sucesso",
		updateSuccess: "Orixá atualizado com sucesso",
		deleteSuccess: "Orixá excluído com sucesso",
		createError: "Erro ao criar orixá",
		updateError: "Erro ao atualizar orixá",
		deleteError: "Erro ao excluir orixá",
		loadError: "Erro ao carregar orixás",
	},
	validation: {
		nameRequired: "O nome é obrigatório",
		nameMaxLength: "O nome deve ter no máximo 100 caracteres",
	},
};
